import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
    name: 'cstDate',
    standalone: false
})
export class CstDatePipe implements PipeTransform {
  transform(date: Date | string, formatString: string = 'MMM Do YY'): string {
    return moment(date).tz('America/Chicago').format(formatString);
  }
}
